export const blackbaudOpenPaymentForm = (transactionData) => {
  Blackbaud_OpenPaymentForm(transactionData);
};

export const getBlackbaudScript = () => {
  const script = document.createElement("script");
  script.src = "https://payments.blackbaud.com/Checkout/bbCheckout.2.0.js";
  script.async = true;

  return script;
};
